/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_WelcomeInputs */

const en_settings_welcome = /** @type {(inputs: Settings_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome back, ${i?.name}`)
};

const zh_settings_welcome = /** @type {(inputs: Settings_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`欢迎回来，${i?.name}`)
};

/**
* | output |
* | --- |
* | "Welcome back, {name}" |
*
* @param {Settings_WelcomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_welcome = /** @type {((inputs: Settings_WelcomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_WelcomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_welcome(inputs)
	return zh_settings_welcome(inputs)
});
export { settings_welcome as "settings.welcome" }